import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TreeItem } from '../models/tree-item';

@Component({
  selector: 'connect-provider-tree',
  templateUrl: 'connect-provider-tree.component.html',
  styleUrls: ['connect-provider-tree.component.scss']
})
export class ConnectProviderTreeComponent implements OnInit {

  @Input() itemsTree: Array<TreeItem> = [];
  @Input() currentItemSelected: TreeItem;
  @Output() selectedItem = new EventEmitter<TreeItem>();

  constructor() {
  }

  ngOnInit() {
  }

  selectItem(item: TreeItem) {
    this.selectedItem.emit(item);
    this.collapseItems(item);
  }

  collapseItems(item: TreeItem) {
    this.itemsTree.forEach(itemTree => {
      if (itemTree.id === item.id)
        itemTree.isExpanded = !itemTree.isExpanded;
    });
  }

  isSelected(item: TreeItem): boolean {
    let isSelected = false;
    if (this.currentItemSelected)
      isSelected = this.currentItemSelected.id === item.id ? true : false;
    return isSelected;
  }
}
